export { default as Comparison } from './Comparison'
export { default as CurrentCustomer } from './CurrentCustomer'
export { default as Hero } from './Hero'
export { default as OfficeMigration } from './OfficeMigration'
export { default as WhyGoogle } from './WhyGoogle'
